import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { Snapshot, SnapshotThreshold } from 'types';

export const getThreshold = async ({
  snapshotId,
  thresholdId,
}: {
  snapshotId: number;
  thresholdId: number;
}): Promise<SnapshotThreshold> => {
  const { data }: { data: Snapshot } = await axios.get(
    `/api/snapshots/${snapshotId}`
  );
  const threshold = data?.thresholds.find(
    (threshold) => threshold.id === thresholdId
  );
  return threshold as SnapshotThreshold;
};

type QueryFnType = typeof getThreshold;

type UseThresholdOptions = {
  snapshotId: number;
  thresholdId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useThreshold = ({
  snapshotId,
  thresholdId,
  config,
}: UseThresholdOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['snapshot', snapshotId, 'thresholds', thresholdId],
    queryFn: () => getThreshold({ snapshotId, thresholdId }),
  });
};
